import { useEffect, useRef } from 'react'
import { usePendenciasSocket as useSocketContext } from '../contexts/PendenciasSocketContext'
import { PendenciaDto } from '../dominios/pendencias/tipos/pendencia'

interface UsePendenciasSocketOptions {
  onPendenciaRecebida?: (pendencia: PendenciaDto, novoContador: number) => void
  onPendenciaAtualizada?: (pendencia: PendenciaDto, novoContador: number) => void
}

export function usePendenciasSocket(options: UsePendenciasSocketOptions = {}) {
  const { connection, isConnected } = useSocketContext()
  const callbacksRef = useRef(options)

  // Atualizar referência dos callbacks sem recriar os listeners
  useEffect(() => {
    callbacksRef.current = options
  }, [options])

  useEffect(() => {
    if (!connection || !isConnected) return

    const handlePendenciaRecebida = (pendencia: PendenciaDto, novoContador: number) => {
      callbacksRef.current.onPendenciaRecebida?.(pendencia, novoContador)
    }

    const handlePendenciaAtualizada = (pendencia: PendenciaDto, novoContador: number) => {
      callbacksRef.current.onPendenciaAtualizada?.(pendencia, novoContador)
    }

    connection.on('PendenciaRecebida', handlePendenciaRecebida)
    connection.on('PendenciaAtualizada', handlePendenciaAtualizada)

    return () => {
      connection.off('PendenciaRecebida', handlePendenciaRecebida)
      connection.off('PendenciaAtualizada', handlePendenciaAtualizada)
    }
  }, [connection, isConnected])
}



